<template>
	<div>
		<div v-if="tasklist" class="taskboard-tasklist">
			<div class="tasklist elevation-2 round-card background-2">
				<div class="tasklist-header background-2 round-card-t">
					<div style="flex: 1 0 auto; display: flex;">
						<v-text-field
							class="fw500"
							:name="'title'"
							:background-color="$vuetify.theme.dark ? 'background-2' : 'background-2'"
							v-model="tasklist.name"
							single-line
							flat
							solo
							hide-details
							dense
							@change="editTasklist(tasklist)"
						></v-text-field>
						<v-btn
							icon
							small
							class="margin-auto"
							:title="allSelected ? 'Deseleziona tutti i task' : 'Seleziona tutti i task'"
							:disabled="!tasklist.tasks || !tasklist.tasks.length"
							@click="$emit('select-all', tasklist.tasks)"
						>
							<v-icon small>{{ allSelected ? 'mdi-checkbox-multiple-marked' : 'mdi-checkbox-multiple-outline' }}</v-icon>
						</v-btn>
						<v-menu
							offset-y
							:min-width="150"
            				content-class="round-card"
							style="height: 100%; margin: auto">
                            <template v-slot:activator="{ on }">							
								<v-btn v-on="on" small icon :loading="deleting" class="margin-auto">
									<v-icon>more_vert</v-icon>
								</v-btn>
                            </template>
							<v-list dense>
								<v-list-item @click="archiveTasklist(tasklist)" :disabled="!isArchivable(tasklist)">
									<v-list-item-title>Archivia Tasklist</v-list-item-title>
								</v-list-item>
								<v-list-item @click="archiveTasklist(tasklist)" :disabled="!isRestorable(tasklist)">
									<v-list-item-title>Ripristina Tasklist</v-list-item-title>
								</v-list-item>
								<v-list-item @click="deleteTasklist()">
									<v-list-item-title class="red--text">Elimina Tasklist</v-list-item-title>
								</v-list-item>
							</v-list>
						</v-menu>
					</div>
				</div>
				<v-divider></v-divider> 


				<div class="tasklist-content background-1">
					<div class="tasklist-tasks background-1" :id="tasklist.id">
						
						<draggable
							:list="tasklist.tasks"
							:options="{
								group:'task',
								animation: 350,
								ghostClass: 'ghost',
								chosenClass: 'chosen',
							}"
							:disabled="checkDisable"
							@start="drag = true"
 							@end="parentOnDrag($event, 'tasks')"
							style="min-height: 50px">

							<template v-for="(task, k) in tasklist.tasks">
								<task :key="k" :task="task" :selects-mode.sync="selectsMode"></task>					
							</template>
                        </draggable>
					</div>
				</div>

				<v-divider></v-divider>

				<div class="tasklist-footer background-2 round-card-b">
					<div class="tasklist-add-task">
						<!-- Input inline per creazione rapida -->
						<div v-if="showInlineInput" class="pa-2">
							<v-text-field
								v-model="newTaskTitle"
								placeholder="Titolo task..."
								dense
								solo
								flat
								hide-details
								autofocus
								single-line
								:loading="savingQuick"
								@keyup.enter="quickAddTask"
								@keyup.esc="cancelQuickAdd"
							>
								<template v-slot:append>
									<v-btn icon small :loading="savingQuick" :disabled="!newTaskTitle.trim()" @click="quickAddTask">
										<v-icon>check</v-icon>
									</v-btn>
									<v-btn icon small @click="cancelQuickAdd">
										<v-icon>close</v-icon>
									</v-btn>
								</template>
							</v-text-field>
						</div>
						<!-- Pulsanti modalità normale -->
						<div v-else class="add-card-button background-2 round-card-b" style="display: flex; align-items: center; justify-content: space-between;">
							<v-btn text small style="margin-left: -8px; text-transform: none !important;" @click="showInlineInput = true">
								<v-icon left>add</v-icon>
								Aggiungi un Task
							</v-btn>
							<v-btn icon x-small @click="addTask()" title="Apri form completo">
								<v-icon small>mdi-card-plus-outline</v-icon>
							</v-btn>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Task from '@/components/common/Task'
import Draggable from 'vuedraggable'

export default {
	name: 'tasklist',
	components: {
		Task,
		Draggable
	},
	
	data() {
		return {
			name: '',
			deleting: false,
			drag: false,
			showInlineInput: false,
			newTaskTitle: '',
			savingQuick: false
		}
	},

	props: {
		tasklist: Object,
		showDialog: Boolean,
		listableType: String,
		listableId: Number,
		selectsMode: Boolean
	},

	computed: {
		checkDisable() {
			return this.$vuetify.breakpoint.smAndDown ? true : false
		},

		allSelected() {
			return !!this.tasklist.tasks && this.tasklist.tasks.length > 0 && this.tasklist.tasks.every(t => t.selected)
		}
	},

	methods: {

		isArchivable(tasklist) {
			let archivable = true
			if(tasklist.archived) {
				return archivable = false
			} else {
				_.forEach(tasklist.tasks, (task) => {
					if(task.archived == false) {
						archivable = false
					}
				})
			}
			return archivable
		},

		isRestorable(tasklist) {
			if(tasklist.archived) {
				return true
			} else {
				return false
			}
		},

		parentOnDrag(event, entity) {
			this.$eventBusUtility.$emit('onDrag', {event: event, entity: entity})
		},

		addTask() {
			this.$eventBusUtility.$emit('addTask', {
				tasklist_id: this.tasklist.id,
				showDialog: true,
			})
		},

		async quickAddTask() {
			if (!this.newTaskTitle.trim()) return;

			this.savingQuick = true;
			try {
				await this.axios.post('tasks/', {
					title: this.newTaskTitle.trim(),
					tasklist_id: this.tasklist.id,
					status: 'todo', // Come il quick-add della kanban: senza stato il task non compare in kanban
					priority: 'c' // Default: media
				})

				this.newTaskTitle = ''
				this.showInlineInput = false

				this.$store.commit('setSnackbar', { timeout: 6000, text: 'Task creato con successo', value: true, color: 'success' })
				this.$eventBusUtility.$emit('initializeTaskboard')
			} catch (error) {
				this.$eventBusUtility.$emit('errorHandler', error);
			} finally {
				this.savingQuick = false;
			}
		},

		cancelQuickAdd() {
			this.newTaskTitle = '';
			this.showInlineInput = false;
		},

		editTasklist(tasklist) {
			if (tasklist && tasklist.name != '' && tasklist.name.length < 255) {
				this.axios.put('tasklists/' + tasklist.id, {tasklist}).then(response => {

				}, response => {
					// error callback
				})
			} else {

			}
		},

		deleteTasklist() {
			this.deleting = true
			this.axios.post('tasklists/delete', { ids: [this.tasklist.id], listable_type: this.listableType }).then(response => {
				this.$eventBusUtility.setSnackbar(response, this.$store)
				this.$eventBusUtility.$emit('initializeTaskboard')

				this.deleting = false
			},
			response => {
				this.deleting = false
			})
		},


		archiveTasklist(tasklist) {
			tasklist.archived = !tasklist.archived
			this.axios.put('tasklists/' + tasklist.id, {tasklist}).then(response => {
				this.$eventBusUtility.$emit('initializeTaskboard')
			}, response => {
				tasklist.archived = !tasklist.archived
			})
		},
	},

}
</script>
<style>
	.taskboard-tasklist {
	    width: 344px;
	    min-width: 344px;
	    max-width: 344px;
	    margin-right: 24px;
	    height: 100%;
	}

	.taskboard-tasklist .tasklist {
        flex-direction: column;
        box-sizing: border-box;
        display: flex;
	    max-height: 100%;
	    border-radius: 2px;
	    transition: box-shadow 150ms ease;
	}
	.taskboard-tasklist .tasklist .tasklist-header {
	    /* border-bottom-color: rgba(0,0,0,.12) !important; */
		display: flex; align-items: center;
	    height: 52px;
	    min-height: 52px;
	    padding: 0 8px 0 16px;
	    /* border-bottom: 1px solid; */
	}

	.taskboard-tasklist .tasklist .tasklist-content {
	    position: relative;
	    min-height: 0;
	    overflow: hidden;
	    overflow-y: auto;
	    -webkit-overflow-scrolling: touch;
	}
	.taskboard-tasklist .tasklist .tasklist-content .tasklist-tasks {
	    position: relative;
	    min-height: 32px;
	    padding: 0 16px;
	}
	.ps {
	    position: relative;
	}
	.ps {
		/* 
	    overflow: hidden!important;
		*/
	    overflow: auto;
	    overflow-anchor: none;
	    -ms-overflow-style: none;
	    touch-action: auto;
	    -ms-touch-action: auto;
	}
	/* CUSTOM */
	.v-menu__activator {
		height: 100%;
	}
	/**/

	/* .ps>.ps__rail-x {
	    z-index: 99999;
	}
	.ps__rail-x {
	    display: none;
	    opacity: 0;
	    transition: background-color .2s linear,opacity .2s linear;
	    -webkit-transition: background-color .2s linear,opacity .2s linear;
	    height: 15px;
	    bottom: 0;
	    position: absolute;
	}

	.ps>.ps__rail-y {
	    z-index: 99999;
	    left: auto!important;
	}

	.ps--active-x>.ps__rail-x, .ps--active-y>.ps__rail-y {
	    display: block;
	    background-color: transparent;
	}
	.ps--active-y>.ps__rail-y {
	    display: block;
	    background-color: transparent;
	}

	.ps .ps__rail-y:hover {
	    background-color: #eee;
	    opacity: .9;
	} */
	.ps__rail-y {
	    display: none;
	    opacity: 0;
	    transition: background-color .2s linear,opacity .2s linear;
	    -webkit-transition: background-color .2s linear,opacity .2s linear;
	    width: 15px;
	    right: 0;
	    position: absolute;
	}
	/* .ps__thumb-y {
	    background-color: #aaa;
	    border-radius: 6px;
	    transition: background-color .2s linear,width .2s ease-in-out;
	    -webkit-transition: background-color .2s linear,width .2s ease-in-out;
	    width: 6px;
	    right: 2px;
	    position: absolute;
	}
	.ps__rail-y.ps--clicking .ps__thumb-y, .ps__rail-y:focus>.ps__thumb-y, .ps__rail-y:hover>.ps__thumb-y {
	    background-color: #999;
	    width: 11px;
	}
	.ps__rail-y:hover>.ps__thumb-y {
	    background-color: #999;
	    width: 11px;
	} */
	.taskboard-tasklist .tasklist .tasklist-footer {
	    border-top-color: rgba(0,0,0,.12) !important;
	}
	.taskboard-tasklist .tasklist .tasklist-footer {
	    display: flex;
	    flex-direction: column;
	    flex: 1 0 auto;
	    min-height: 48px;
	}
	.tasklist-add-task .add-card-button {
	    position: relative;
	    height: 48px;
	    min-height: 48px;
	    padding: 0 16px;
	    text-align: left;
	    text-transform: none;
	    font-weight: 600;
	    font-size: 14px;
	    cursor: pointer;
	}
</style>